import { lazy, ReactElement } from 'react';
import { Result } from 'antd';
import { EAppRoutes } from '@common/enums';
import { IRouteItem } from '@common/interfaces';
import { generateRouteElements } from './generateRouteElements';

const DevicesContainerLazy = lazy(() => import('@features/targeting/containers/categories/Devices/DevicesContainer'));
const OperatingSystemContainerLazy = lazy(
  () => import('@features/targeting/containers/categories/OperatingSystem/OperatingSystemContainer')
);
const BrowserContainerLazy = lazy(() => import('@features/targeting/containers/categories/Browser/BrowserContainer'));
const BannerPlacementContainerLazy = lazy(
  () => import('@features/targeting/containers/categories/BannerPlacement/BannerPlacementContainer')
);
const VideoPlacementContainerLazy = lazy(
  () => import('@features/targeting/containers/categories/VideoPlacement/VideoPlacementContainer')
);
const FrequencyTargetingContainerLazy = lazy(
  () => import('@features/targeting/containers/categories/FreqCap/FreqCapContainer')
);
const TargetingInventoryDealsContainerLazy = lazy(
  () => import('@features/targeting/containers/categories/Deals/DealsContainer')
);
const SupplySourceContainerLazy = lazy(
  () => import('@features/targeting/containers/categories/Supply/SourceSupplyContainer')
);
const VerifiedSupplyContainerLazy = lazy(
  () => import('@features/targeting/containers/categories/Supply/VerifiedSupplyContainer')
);
const SiteAndAppContainerLazy = lazy(
  () => import('@features/targeting/containers/categories/AppSiteList/AppSiteListContainer')
);
const IabCategoryContainerLazy = lazy(
  () => import('@features/targeting/containers/categories/IabCategory/IabCategoryContainer')
);
const CreativeBannerPlacementContainerLazy = lazy(
  () => import('@features/targeting/containers/categories/CreativeType/CreativeBanner/CreativeBannerContainer')
);
const CreativeNativePlacementContainerLazy = lazy(
  () => import('@features/targeting/containers/categories/CreativeType/CreativeNative/CreativeNativeContainer')
);
const CreativeAudioPlacementContainerLazy = lazy(
  () => import('@features/targeting/containers/categories/CreativeType/CreativeAudio/CreativeAudioContainer')
);
const CreativeVideoPlacementContainerLazy = lazy(
  () => import('@features/targeting/containers/categories/CreativeType/CreativeVideo/CreativeVideoContainer')
);
const IabFormatsContainerLazy = lazy(
  () => import('@features/targeting/containers/categories/CreativeType/IabFormats/IabFormatsContainer')
);
const PointOfInterestContainerLazy = lazy(
  () => import('@features/targeting/containers/categories/PointOfInterest/PointOfInterestContainer')
);
const GeoAreaContainerLazy = lazy(() => import('@features/targeting/containers/categories/GeoArea/GeoAreaContainer'));
const TimePartingContainerLazy = lazy(
  () => import('@features/targeting/containers/categories/TimeParting/TimePartingContainer')
);
const CarrierContainerLazy = lazy(() => import('@features/targeting/containers/categories/Carrier/CarrierContainer'));
const GenreLazy = lazy(
  () => import('@features/targeting/components/categories/Genre/containers/GenreContainer/GenreContainer')
);
const LanguageLazy = lazy(
  () => import('@features/targeting/components/categories/Language/containers/LanguageContainer/LanguageContainer')
);
const LiveLazy = lazy(
  () => import('@features/targeting/components/categories/Live/containers/LiveContainer/LiveContainer')
);
const ProductionLazy = lazy(
  () =>
    import('@features/targeting/components/categories/Production/containers/ProductionContainer/ProductionContainer')
);
const RatingLazy = lazy(
  () => import('@features/targeting/components/categories/Rating/containers/RatingContainer/RatingContainer')
);
const DvViewabilityLazy = lazy(
  () =>
    import(
      '@features/targeting/components/categories/DvViewability/containers/DVViewabilityContainer/DvViewabilityContainer'
    )
);
const BssAbsViewabilityLazy = lazy(() => import('@features/targeting/containers/categories/BssAbs/BssAbsContainer'));
const AppCategoryLazy = lazy(
  () =>
    import('@features/targeting/components/categories/AppCategory/containers/AppCategoryContainer/AppCategoryContainer')
);

const routeItems: IRouteItem[] = [
  { path: EAppRoutes.TargetingOs, component: <OperatingSystemContainerLazy /> },
  { path: EAppRoutes.TargetingDeviceType, component: <DevicesContainerLazy /> },
  { path: EAppRoutes.TargetingInventoryBrowser, component: <BrowserContainerLazy /> },
  { path: EAppRoutes.TargetingBannerPlacement, component: <BannerPlacementContainerLazy /> },
  { path: EAppRoutes.TargetingVideoPlacement, component: <VideoPlacementContainerLazy /> },
  { path: EAppRoutes.TargetingCreativeBanner, component: <CreativeBannerPlacementContainerLazy /> },
  { path: EAppRoutes.TargetingCreativeNative, component: <CreativeNativePlacementContainerLazy /> },
  { path: EAppRoutes.TargetingCreativeAudio, component: <CreativeAudioPlacementContainerLazy /> },
  { path: EAppRoutes.TargetingCreativeVideo, component: <CreativeVideoPlacementContainerLazy /> },
  { path: EAppRoutes.TargetingIabFormats, component: <IabFormatsContainerLazy /> },
  { path: EAppRoutes.TargetingFrequency, component: <FrequencyTargetingContainerLazy /> },
  { path: EAppRoutes.TargetingSupplySource, component: <SupplySourceContainerLazy /> },
  { path: EAppRoutes.TargetingVerifiedSource, component: <VerifiedSupplyContainerLazy /> },
  { path: EAppRoutes.TargetingSiteAndApp, component: <SiteAndAppContainerLazy /> },
  { path: EAppRoutes.TargetingIabCategory, component: <IabCategoryContainerLazy /> },
  { path: EAppRoutes.TargetingGeo, component: <GeoAreaContainerLazy /> },
  { path: EAppRoutes.TargetingLanguage, component: <LanguageLazy /> },
  { path: EAppRoutes.TargetingGenre, component: <GenreLazy /> },
  { path: EAppRoutes.TargetingLive, component: <LiveLazy /> },
  { path: EAppRoutes.TargetingProduction, component: <ProductionLazy /> },
  { path: EAppRoutes.TargetingRating, component: <RatingLazy /> },
  { path: EAppRoutes.TargetingInventoryDeals, component: <TargetingInventoryDealsContainerLazy /> },
  { path: EAppRoutes.TargetingLocationPOI, component: <PointOfInterestContainerLazy /> },
  { path: EAppRoutes.TargetingDayParting, component: <TimePartingContainerLazy /> },
  { path: EAppRoutes.TargetingCarrier, component: <CarrierContainerLazy /> },
  { path: EAppRoutes.ViewabilityProduction, component: <DvViewabilityLazy /> },
  { path: EAppRoutes.ViewabilityBssAbs, component: <BssAbsViewabilityLazy /> },
  { path: EAppRoutes.TargetingAppCategory, component: <AppCategoryLazy /> },
  { path: '*', component: <Result status='404' title='This section in progress' /> },
];

export const targetingRoutes: ReactElement[] = generateRouteElements(routeItems);
